import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import d2MenuSide from './components/menu-side';
import d2MenuHeader from './components/menu-header';
import d2Tabs from './components/tabs';
import d2HeaderFullscreen from './components/header-fullscreen';
import d2HeaderLocales from './components/header-locales';
import d2HeaderSearch from './components/header-search';
import d2HeaderSize from './components/header-size';
import d2HeaderTheme from './components/header-theme';
import d2HeaderUser from './components/header-user';
import d2HeaderLog from './components/header-log';
import d2HeaderColor from './components/header-color';
import { mapState, mapGetters, mapActions } from 'vuex';
import mixinSearch from './mixins/search';
import helper from '@/libs/helper.js';
import axios from '@/plugin/axios';
export default {
  name: 'd2-layout-header-aside',
  mixins: [mixinSearch],
  components: {
    d2MenuSide: d2MenuSide,
    d2MenuHeader: d2MenuHeader,
    d2Tabs: d2Tabs,
    d2HeaderFullscreen: d2HeaderFullscreen,
    d2HeaderLocales: d2HeaderLocales,
    d2HeaderSearch: d2HeaderSearch,
    d2HeaderSize: d2HeaderSize,
    d2HeaderTheme: d2HeaderTheme,
    d2HeaderUser: d2HeaderUser,
    d2HeaderLog: d2HeaderLog,
    d2HeaderColor: d2HeaderColor
  },
  data: function data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px',
      value: '',
      options: [],
      sys_info: {
        content: {
          logo: ''
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin', {
    keepAlive: function keepAlive(state) {
      return state.page.keepAlive;
    },
    grayActive: function grayActive(state) {
      return state.gray.active;
    },
    transitionActive: function transitionActive(state) {
      return state.transition.active;
    },
    asideCollapse: function asideCollapse(state) {
      return state.menu.asideCollapse;
    },
    asideTransition: function asideTransition(state) {
      return state.menu.asideTransition;
    },
    count: function count(state) {
      return state.user.count;
    },
    version: function version(state) {
      return state.user.version;
    },
    hasNotify: function hasNotify(state) {
      return state.user.hasNotify;
    }
  })), mapGetters('d2admin', {
    themeActiveSetting: 'theme/activeSetting'
  })), {}, {
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup: function styleLayoutMainGroup() {
      return this.themeActiveSetting.backgroundImage ? {
        backgroundImage: "url('".concat(this.$baseUrl).concat(this.themeActiveSetting.backgroundImage, "')")
      } : {};
    }
  }),
  created: function created() {
    //this.loadGuanjian();
    //this.loadAreaList();
    // this.loadData();
    this.loadBase();
    this.getFirstCurrentVersion();
    this.startGetVersion();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/menu', ['asideCollapseToggle'])), mapActions('d2admin/page', ['closeAll'])), {}, {
    /**
     * 接收点击切换侧边栏的按钮
     */
    loadBase: function loadBase() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, url, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // console.log('load menu1');
              //加载菜单
              // console.log('data placeid', this.placeId);
              data = {
                id: localStorage['admin_id'],
                username: localStorage['username']
              }; // console.log("menu data2",data);
              url = helper.apiHost + '/index/getBase';
              _context.next = 4;
              return axios({
                url: url,
                method: 'post',
                data: data
              });
            case 4:
              res = _context.sent;
              // console.log("menu res",res);
              if (res.code == 0) {
                _this.sys_info = res.data.sys_info;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getFirstCurrentVersion: function getFirstCurrentVersion() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var that, url, data, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = _this2;
              url = helper.apiHost + '/system/getVersion';
              data = {};
              _context2.next = 5;
              return axios(url, {
                params: data
              });
            case 5:
              response = _context2.sent;
              if (response.code == 0) {
                // console.log('version', response.data);
                // console.log('current', this.version);
                if (_this2.version != response.data) {
                  // console.log('not equal')
                  _this2.$store.dispatch('d2admin/user/setVersion', response.data, {
                    root: true
                  });
                }
              } else {}
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    startGetVersion: function startGetVersion() {
      var that = this;
      // that.getCurrentTeamMessage();
      setInterval(function () {
        if (localStorage['admin_id']) {
          that.getCurrentVersion();
        }
      }, 1000 * 60 * 5);
    },
    getCurrentVersion: function getCurrentVersion() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var that, url, data, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = _this3;
              url = helper.apiHost + '/system/getVersion';
              data = {};
              _context3.next = 5;
              return axios(url, {
                params: data
              });
            case 5:
              response = _context3.sent;
              if (response.code == 0) {
                // console.log('version', response.data);
                // console.log('current', this.version);
                if (_this3.version != response.data) {
                  // console.log('not equal')
                  _this3.$store.dispatch('d2admin/user/setVersion', response.data, {
                    root: true
                  });
                  console.log('notify', _this3.hasNotify);
                  if (_this3.hasNotify <= 0) {
                    _this3.$notify({
                      title: '提示',
                      dangerouslyUseHTMLString: true,
                      message: '<div>当前有新版本更新，请点击确定刷新页面，或键盘按下 CTRL+F5 刷新页面</div><div><button onclick="location.reload();">刷新页面</button></div>',
                      duration: 0,
                      position: 'top-left',
                      showClose: false
                    });
                    _this3.$store.dispatch('d2admin/user/setHasNotify', 1, {
                      root: true
                    });
                  }
                }
              } else {}
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    loadData: function loadData() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var that, url, data, response, placeId, flag;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = _this4;
              url = helper.apiHost + helper.apiUrl.getIndexSelectList;
              data = {};
              _context4.next = 5;
              return axios(url, {
                params: data
              });
            case 5:
              response = _context4.sent;
              if (response.code == 0) {
                _this4.options = response.data;
                placeId = localStorage.getItem('place_id');
                if (placeId) {
                  placeId = parseInt(placeId);
                }
                if (response.data.length > 0) {
                  flag = false;
                  response.data.forEach(function (item) {
                    if (item.id == placeId) {
                      flag = true;
                    }
                  });
                  if (!flag) {
                    that.value = response.data[0].id;
                    localStorage.setItem('place_id', response.data[0].id);
                  } else {
                    that.value = placeId;
                  }
                }
              } else {}
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    jumpMessage: function jumpMessage() {
      this.$router.push({
        path: '/message'
      });
    },
    handleToggleAside: function handleToggleAside() {
      this.asideCollapseToggle();
    },
    onPlaceChange: function onPlaceChange(e) {
      var page = this;
      console.log('e', e);
      localStorage.setItem("place_id", e);
      this.closeAll();
      setTimeout(function () {
        location.reload();
      }, 200);
    }
  })
};